import { Modal } from "ui";

import { useCreateFeedInsert, useUpdateFeedInsert } from "../../../apis";
import {
  convertFeedInsertFormDataToCreateRequestBody,
  getInitialFeedInsertFormValues
} from "../../../helpers";
import { FeedInsertForm, FeedInsertFormValues } from "../../forms";
import { FeedInsertModalProps } from "./FeedInsertModal.types";

const FEED_INSERT_FORM_ID = "feed-insert-form-id";

const FeedInsertModal = ({
  isOpen,
  onClose,
  editableInsert
}: FeedInsertModalProps) => {
  const updateFeedInsert = useUpdateFeedInsert({
    onSuccess: onClose
  });

  const createFeedInsert = useCreateFeedInsert({
    onSuccess: onClose
  });

  const handleFormSubmit = (formData: FeedInsertFormValues) => {
    if (formData.id) {
      const requestBody = {
        id: formData.id,
        ...convertFeedInsertFormDataToCreateRequestBody(formData)
      };

      updateFeedInsert.mutate(requestBody);
    } else {
      createFeedInsert.mutate(
        convertFeedInsertFormDataToCreateRequestBody(formData)
      );
    }
  };

  return (
    <Modal
      formId={FEED_INSERT_FORM_ID}
      isOpen={isOpen}
      title={`${editableInsert ? "Edit" : "Add"} Feed Insert`}
      isLoading={createFeedInsert.isLoading}
      okText={editableInsert ? "Save" : "Add"}
      onClose={onClose}
    >
      <FeedInsertForm
        formId={FEED_INSERT_FORM_ID}
        onSubmit={handleFormSubmit}
        defaultValues={getInitialFeedInsertFormValues(editableInsert)}
      />
    </Modal>
  );
};

export default FeedInsertModal;
